export default __webpack_public_path__ + "static/media/soal17.bac71279.jpg";